// components/ProtectedCRM.jsx
import React, { useEffect, useState } from "react";
import { Flex, Spinner, VStack, Heading, Text } from "@chakra-ui/react";
import { auth } from "../firebase";

const OWNER_EMAILS = new Set(["danielecarvalhodossantos00@gmail.com"].map(e => e.toLowerCase()));
const CRM_EMAILS = new Set([/* aggiungi qui in futuro */].map(e => e.toLowerCase()));

export default function ProtectedCRM({ children }) {
    const [loading, setLoading] = useState(true);
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        const unsub = auth.onAuthStateChanged(async (u) => {
            if (!u) { setAllowed(false); setLoading(false); return; }

            const email = (u.email || "").toLowerCase();

            // supporta sia whitelist che custom claims (role: 'owner' | 'crm')
            let role = null;
            try {
                const t = await u.getIdTokenResult(true);
                role = t.claims?.role || null;
            } catch { /* ignore */ }

            const ok =
                role === "owner" ||
                role === "crm" ||
                OWNER_EMAILS.has(email) ||
                CRM_EMAILS.has(email);

            setAllowed(ok);
            setLoading(false);
        });

        return () => unsub && unsub();
    }, []);

    if (loading) {
        return (
            <Flex minH="60vh" align="center" justify="center">
                <Spinner />
            </Flex>
        );
    }
    if (!allowed) {
        return (
            <Flex minH="60vh" align="center" justify="center">
                <VStack>
                    <Heading size="md">Accesso negato</Heading>
                    <Text>Sezione riservata al team.</Text>
                </VStack>
            </Flex>
        );
    }
    return children;
}
